import type { DisciplineScheduleStorePayload } from '../model/interfaces'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleStoreApiOptions {
  disciplineId: string | number
  activationRunId: number
  payload: DisciplineScheduleStorePayload
}

/** `POST /admin-api/disciplines/{discipline}/schedule/{activationRun}` — creates the lessons and assigns the tutor
 *  before it answers. A run can be stored once: the caller never retries on its own. */
export const useDisciplineScheduleStoreApi = async (options: DisciplineScheduleStoreApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.store', {
    discipline_id: options.disciplineId,
    activation_run_id: options.activationRunId,
  })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.post(url, options.payload)
    toast.success({ title: 'Successfully created!', description: 'Weekly schedule was successfully created' })

    return true
  } catch (err: unknown) {
    toast.error({ title: 'Error!', description: getAxiosErrorMessage(err) })
    return false
  }
}
